<template>
  <div>
    <h2>{{ title }}</h2>

    <b-row class="mb-4">
      <b-col>
        <b-container fluid>
          <h5 class="w-full text-center">Questions</h5>
          <div class="content-diff-list">
            <!-- Summary -->
            <div class="content-diff-item bg-light">
              <div class="d-flex justify-content-around">
                <div class="d-flex flex-column align-items-center">
                  <div class="h4 mb-0 text-success">
                    {{ createdQuestions }}
                  </div>
                  <small class="text-muted"
                    >Addition{{ createdQuestions > 1 ? 's' : '' }}</small
                  >
                  <b-button
                    variant="info"
                    size="sm"
                    class="mt-2"
                    :disabled="!createdQuestions"
                    @click="showDetailsEvent('questions', 'created')"
                    >Details</b-button
                  >
                </div>
                <div class="d-flex flex-column align-items-center">
                  <div class="h4 mb-0 text-warning">
                    {{ updatedQuestions }}
                  </div>
                  <small class="text-muted"
                    >Edit{{ updatedQuestions > 1 ? 's' : '' }}</small
                  >
                  <b-button
                    variant="info"
                    size="sm"
                    class="mt-2"
                    :disabled="!updatedQuestions"
                    @click="showDetailsEvent('questions', 'updated')"
                    >Details</b-button
                  >
                </div>
                <div class="d-flex flex-column align-items-center">
                  <div class="h4 mb-0 text-danger">
                    {{ deletedQuestions }}
                  </div>
                  <small class="text-muted"
                    >Deletion{{ deletedQuestions > 1 ? 's' : '' }}</small
                  >
                  <b-button
                    variant="info"
                    size="sm"
                    class="mt-2"
                    :disabled="!deletedQuestions"
                    @click="showDetailsEvent('questions', 'deleted')"
                    >Details</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </b-col>
      <b-col>
        <b-container fluid>
          <div class="flex-center"><h5>Games</h5></div>
          <div class="content-diff-list">
            <!-- Summary -->
            <div class="content-diff-item bg-light">
              <div class="d-flex justify-content-around">
                <div class="d-flex flex-column align-items-center">
                  <div class="h4 mb-0 text-success">
                    {{ createdGames }}
                  </div>
                  <small class="text-muted"
                    >Addition{{ createdGames > 1 ? 's' : '' }}</small
                  >
                  <b-button
                    variant="info"
                    size="sm"
                    class="mt-2"
                    :disabled="!createdGames"
                    @click="showDetailsEvent('games', 'created')"
                    >Details</b-button
                  >
                </div>
                <div class="d-flex flex-column align-items-center">
                  <div class="h4 mb-0 text-warning">
                    {{ updatedGames }}
                  </div>
                  <small class="text-muted"
                    >Edit{{ updatedGames > 1 ? 's' : '' }}</small
                  >
                  <b-button
                    variant="info"
                    size="sm"
                    class="mt-2"
                    :disabled="!updatedGames"
                    @click="showDetailsEvent('games', 'updated')"
                    >Details</b-button
                  >
                </div>
                <div class="d-flex flex-column align-items-center">
                  <div class="h4 mb-0 text-danger">
                    {{ deletedGames }}
                  </div>
                  <small class="text-muted"
                    >Deletion{{ deletedGames > 1 ? 's' : '' }}</small
                  >
                  <b-button
                    variant="info"
                    size="sm"
                    class="mt-2"
                    :disabled="!deletedGames"
                    @click="showDetailsEvent('games', 'deleted')"
                    >Details</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  // import QuestionContentResume from './question/QuestionContentResume.vue'
  // import GameContentResume from './game/GameContentResume.vue'
  export default {
    name: 'ContentDiffStats',
    components: {
      // QuestionContentResume,
      // GameContentResume,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      createdQuestions: {
        type: Number,
        default: 0,
      },
      updatedQuestions: {
        type: Number,
        default: 0,
      },
      deletedQuestions: {
        type: Number,
        default: 0,
      },
      createdGames: {
        type: Number,
        default: 0,
      },
      updatedGames: {
        type: Number,
        default: 0,
      },
      deletedGames: {
        type: Number,
        default: 0,
      },
    },
    methods: {
      showDetailsEvent(type, status) {
        this.$emit('show-details', { type, status })
      },
    },
  }
</script>
